/**
 * Mixin for displaying snacks
 */
import Vue from "vue";

export default Vue.extend({
  methods: {
    displaySnack(
      text: string,
      options: { timeout?: number; color?: string } = {}
    ): void {
      this.$root.$emit("displaySnack", text, options);
    },
  },
});
